import { observable, flow, makeObservable } from "mobx";
import { appStore } from "../";
import { PostscriptCategory, PostscriptNotification, PostscriptTerm } from "./index";
import { EAIClient } from "Services/EAIClient";

export class PostscriptStore {
    client: EAIClient = new EAIClient();

    @observable isUpdatingTerms = false;
    @observable terms: PostscriptTerm[] = [];
    @observable defaultExpressions: string[] = [];

    @observable isUpdatingCategories = false;
    @observable categories: PostscriptCategory[] = [];

    @observable isUpdatingNotifications = false;
    @observable notificationSettings: PostscriptNotification | undefined = undefined;
    constructor() {
        makeObservable(this);
    }

    @flow
    *fetchDefaultExpressions(){
        try {
            const resp = yield this.client.listDefaultPostscriptExpressions();
            this.defaultExpressions = resp.data.data;
        } catch(e) {
            appStore.addError(e);
        }
    }

    @flow
    *fetchTerms(){
        this.isUpdatingTerms = true;
        try {
            const resp = yield this.client.listPostscriptTerms();
            this.terms = resp.data.data;
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isUpdatingTerms = false;
        }
    }

    @flow
    *createTerm(term: Partial<PostscriptTerm>): any {
        this.isUpdatingTerms = true;
        try {
            yield this.client.createPostscriptTerm(term);
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isUpdatingTerms = false;
        }
    }

    @flow
    *updateTerm(termId: number, term: Partial<PostscriptTerm>): any {
        this.isUpdatingTerms = true;
        try {
            yield this.client.updatePostscriptTerm(termId, term);
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isUpdatingTerms = false;
        }
    }

    @flow
    *deleteTerm(termId: number): any {
        this.isUpdatingTerms = true;
        try {
            yield this.client.deletePostscriptTerm(termId);
            this.fetchTerms();
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isUpdatingTerms = false;
        }
    }

    @flow
    *testRegex(term, expression, functionType): any {
        try {
            return this.client.testRegex(term, expression, functionType);
        } catch(e){
            appStore.addError(e);
        }
    }

    @flow
    *fetchCategories(): any {
        this.isUpdatingCategories = true;
        try {
            const resp = yield this.client.listPostscriptCategories();
            this.categories = resp.data.data;
        } catch(e){
            appStore.addError(e);
        } finally {
            this.isUpdatingCategories = false;
        }

    }

    @flow
    *createCategory(category: Partial<PostscriptCategory>): any {
        this.isUpdatingCategories = true;
        try {
            yield this.client.createPostscriptCategory(category);
        } catch(e){
            appStore.addError(e);
        } finally {
            this.isUpdatingCategories = false;
        }
    }

    @flow
    *updateCategory(categoryId: number, category: Partial<PostscriptCategory>): any {
        this.isUpdatingCategories = true;
        try {
            yield this.client.updatePostscriptCategory(categoryId, category);
        } catch(e){
            appStore.addError(e);
        } finally {
            this.isUpdatingCategories = false;
        }
    }

    @flow
    *deleteCategory(categoryId: number): any {
        this.isUpdatingCategories = true;
        try {
            yield this.client.deletePostscriptCategory(categoryId);
            this.fetchCategories();
        } catch(e){
            appStore.addError(e);
        } finally {
            this.isUpdatingCategories = false;
        }
    }
}